import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../modules/shared.module';
import { EguardSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        EguardSearchBarComponent
    ],
    imports     : [
        SharedModule,
        RouterModule
    ],
    exports     : [
        EguardSearchBarComponent
    ]
})
export class EguardSearchBarModule
{
}



// WEBPACK FOOTER //
// ./src/app/core/components/search-bar/search-bar.module.ts